import { actionCreator } from '@ardoq/rxbeach';
import { FavoritePayload } from '@ardoq/api';
import {
  APICurrentUser,
  ArdoqId,
  PersonalSettingMap,
  ViewIds,
} from '@ardoq/api-types';
import { AppModules } from '../../appContainer/types';
import { WidgetState } from '../../homePage/viewpointsWidget/types';

export const acceptTermsAndPrivacyPolicy = actionCreator<ArdoqId>(
  '[currentUser] ACCEPT_TERMS_AND_PRIVACY_POLICY'
);

export const toggleFavorite = actionCreator<FavoritePayload>(
  '[currentUser] TOGGLE_FAVORITE'
);

export const toggleModelPreview = actionCreator(
  '[currentUser] TOGGLE_MODEL_PREVIEW'
);

export const updateCurrentUser = actionCreator(
  '[currentUser] UPDATE_CURRENT_USER'
);

export const receivedUpdatedCurrentUser = actionCreator<APICurrentUser>(
  '[currentUser] RECEIVED_UPDATED_CURRENT_USER'
);

type ChangeAssetsBrowserPerPagePayload = {
  appModule: AppModules;
  perPage: number;
};

export const updateAssetsBrowserPerPageSettings =
  actionCreator<ChangeAssetsBrowserPerPagePayload>(
    '[currentUser] UPDATE_ASSETS_BROWSER_PER_PAGE_SETTINGS'
  );

export const updateHomepageViewpointsState = actionCreator<
  Partial<WidgetState>
>('[currentUser] UPDATE_HOMEPAGE_VIEWPOINTS_STATE');

// These types ensure you are not allowed to give an incorrect newValue payload for a given person setting.
type UpdatePersonalSettingPayload<T extends keyof PersonalSettingMap> = {
  personalSetting: T;
  newValue: PersonalSettingMap[T];
};

export type UpdatePersonalSettingUnion = {
  [K in keyof PersonalSettingMap]-?: UpdatePersonalSettingPayload<K>;
}[keyof PersonalSettingMap];

export const updatePersonalSetting = actionCreator<UpdatePersonalSettingUnion>(
  '[currentUser] UPDATE_PERSONAL_SETTING'
);

export const setPersonalSetting = actionCreator<UpdatePersonalSettingUnion>(
  '[currentUser] SET_PERSONAL_SETTING'
);

/** Like `setPersonalSetting`, but a failed save is only logged. */
export const setPersonalSettingInBackground =
  actionCreator<UpdatePersonalSettingUnion>(
    '[currentUser] SET_PERSONAL_SETTING_IN_BACKGROUND'
  );

export const viewStyleUsed = actionCreator<ViewIds>(
  '[currentUser] VIEW_STYLE_USED'
);
